import React from 'react';
import { NavLink as Link } from 'react-router-dom';

const Header = () => {
  const user = localStorage.getItem('eko-360-p2-user') || null;

  return (
    <>
      <style>{`
        .custom-nav-link {
          color: #212529 !important;
          transition: color 0.2s ease-in-out, border-color 0.2s ease-in-out;
          border-bottom: 2px solid transparent;
          text-decoration: none;
        }
        .custom-nav-link:hover {
          color: #0C9EA9 !important;
          border-bottom: 2px solid #0C9EA9;
        }
        .custom-nav-link.active-link {
          color: #0C9EA9 !important;
          font-weight: 700 !important;
          border-bottom: 2px solid #0C9EA9;
        }
        .custom-dropdown-item {
          color: #333;
          transition: background-color 0.2s ease, color 0.2s ease;
        }
        .custom-dropdown-item:hover, .custom-dropdown-item.active-link {
          background-color: rgba(12, 158, 169, 0.08);
          color: #0C9EA9 !important;
          font-weight: 600;
        }
      `}</style>

      <div className="collapse navbar-collapse" id="navmenu">
        <ul className="navbar-nav ms-auto align-items-center gap-4 text-uppercase fw-semibold" style={{ fontSize: '13px', letterSpacing: '0.8px' }}>
          <li className="nav-item">
            <Link
              exact
              to="/"
              className="nav-link custom-nav-link px-1 py-1"
              activeClassName="active-link"
            >
              Search
            </Link>
          </li>

          <li className="nav-item dropdown">
            <a
              className="nav-link custom-nav-link px-1 py-1 dropdown-toggle"
              href="#"
              id="exploreDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Explore
            </a>
            <ul className="dropdown-menu dropdown-menu-end shadow-sm border-0 rounded-3 mt-2" aria-labelledby="exploreDropdown">
              <li>
                <Link to="/interactivity" className="dropdown-item custom-dropdown-item py-2 fs-6 text-capitalize" activeClassName="active-link">
                  Interactive Analysis
                </Link>
              </li>
              <li>
                <Link to="/slice-and-dice" className="dropdown-item custom-dropdown-item py-2 fs-6 text-capitalize" activeClassName="active-link">
                  Slice & Dice
                </Link>
              </li>
            </ul>
          </li>

          <li className="nav-item">
            <Link
              to="/submit-dataset"
              className="nav-link custom-nav-link px-1 py-1"
              activeClassName="active-link"
            >
              Submit Dataset
            </Link>
          </li>
           <li className="nav-item">
            <Link
              to="/events-360"
              className="nav-link custom-nav-link px-1 py-1"
              activeClassName="active-link"
            >
              Events 360
            </Link>
          </li>

          <li className="nav-item">
            <Link
              to="/publications"
              className="nav-link custom-nav-link px-1 py-1"
              activeClassName="active-link"
            >
              Publications
            </Link>
          </li>

          <li className="nav-item">
            <Link
              to="/public/datasets"
              className="nav-link custom-nav-link px-1 py-1"
              activeClassName="active-link"
            >
              Public Data
            </Link>
          </li>

          <li className="nav-item">
            <Link
              to="/about/mission-and-vision"
              className="nav-link custom-nav-link px-1 py-1"
              activeClassName="active-link"
            >
              About
            </Link>
          </li>

          <li className="nav-item">
            <Link
              to="/faqs"
              className="nav-link custom-nav-link px-1 py-1"
              activeClassName="active-link"
            >
              FAQs
            </Link>
          </li>

          {!user && (
            <li className="nav-item ms-lg-2">
              <Link
                to="/login"
                className="btn text-white rounded-pill px-4 py-2 text-capitalize fw-semibold shadow-sm"
                style={{ backgroundColor: '#0C9EA9', fontSize: '14px', border: 'none' }}
              >
                Sign In
              </Link>
            </li>
          )}
        </ul>
      </div>
    </>
  );
};

export default Header;